module.exports = __webpack_public_path__ + "static/media/portfolio-04 copy.fe251a20.jpg";